import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { ILogImage } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class LogImageService extends BaseService<ILogImage> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'logImage');
  }
}

export { ILogImage } from '../shared/api';
